import { IDeleteDiarioObraEfetivoUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_efetivo_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraUseCase

export class DeleteDiarioObraEfetivoUseCase implements IDeleteDiarioObraEfetivoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObraEfetivo(IdDiarioObras: number, IdDiarioObrasEfetivo: number): Promise<void> {
    await this.repository.deleteDiarioObraEfetivo(IdDiarioObras, IdDiarioObrasEfetivo);
  }
}
